import type { AccommodationState } from '@/interfaces';
import { connect } from 'react-redux';
import { SearchForm, type SearchFormProps } from '@/containers/searchForm/SearchForm';
import { nameOverrides } from '@/utils/nameOverrides';

const mapStateToProps = (state: AccommodationState): Omit<SearchFormProps, 'checkinDateRef' | 'defaultErrorOnMissingDates'> => {
    const countryName = state.searchResults.destination?.hierarchy ? state.searchResults.destination.hierarchy[0]?.name : undefined;
    const destinationName = state.searchResults.destination?.hierarchy
        ? state.searchResults.destination.hierarchy[state.searchResults.destination.hierarchy.length - 1]?.name
        : undefined;
    const hierarchy = countryName === destinationName ? [countryName] : [countryName, destinationName];
    const destinationFullName = state.filters.mapBounds
        ? 'Kartutsnitt'
        : nameOverrides[state.filters.destination?.toLowerCase()] ||
          state.searchResults.destination?.fullName ||
          state.filters.destination?.replace(/_/g, ' ') ||
          state.searchResults.searchConfig?.title;
    return {
        position: state.map.open ? 'map' : 'listing',
        placeKey: state.filters.destination,
        hierarchy: hierarchy.filter((name) => !!name),
        destinationFullName,
        initialCheckInDate: state.filters.checkInDate,
        initialCheckOutDate: state.filters.checkOutDate,
        initialRooms: state.filters.rooms,
        initialMapBounds: state.filters.mapBounds,
        mapOpen: state.map.open,
        searchConfig: state.searchResults.searchConfig,
        className: 'u-mt16--lt768 result-list-search-form',
    };
};

export const SearchResultsSearchForm = connect(mapStateToProps)(SearchForm);
